
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["woman_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M806.684 643.758c-15.02-89.024-47.528-132.312-67.534-159.423-5.04-6.827-16.545-13.464-30.932-19.574 35.61-22.267 33.375-70.508 16.085-87.08 0 0-11.597 23.83-32.202 18.026 0 0 29.305-8.366 19.646-33.477 0 0-12.243 16.092-27.366 3.871C669.24 353.858 752.804 84.59 522.43 64.74c0 0-178.35-18.03-188.655 164.846 0 0-5.48 26.887-29.138 20.599-23.667-6.278-12.071-26.559-12.071-26.559s-64.72 41.532-8.7 88.867c0 0-22.214 8.523-31.858-11.425 0 0-4.522 70.836 47.627 70.19 0 0-19.959 14.166-37.984 6.435 0 0 65.695 110.759 171.29 34.123 0 0-24.474-44.429-21.906-89.502 2.589-45.07 72.128-79.203 79.849-139.736 0 0 75.337 0 105.61 54.098 0 0-10.298-41.225-39.28-57.317 0 0 57.937 14.801 62.782 63.095 10.242 102.33-36.712 160.345-41.542 163.237l-4.83 2.9s-.328 11.257 5.516 24.589c-5.908 18.54-25.468 63.307-77.56 67.937-65.872 5.862-82.97-63.376-82.97-63.376-14.598 17.207-42.105 25.116-105.477 44.163-63.371 19.036-64.438 67.09-71.716 84.824-14.415 35.135-58.902 391.78-58.902 391.78l656.174 5.336c.002 0-17.002-231.073-32.006-320.085z","fill":"#CCC"}})])
          )
        }
      }
    